import { BU } from './BU';
import { Region } from './Region';
import { Attributes } from './Attributes';
import { HierarchyTranslation } from './HierarchyTranslation';
import { SubBU } from './SubBU';
import { Site } from './Site';
import { SRU } from './sru';
import { Department } from './Department';
import { Crew } from './Crew';



export class SubSite { 
    SubSiteId:number;
    SubSiteName: string;
    BUName:string;
    BUId:number;
    RegionId: number;
    RegionName: string;
    SubBUId: number;
    SubBUName: string;
    SiteId:number;
    SiteName:String;
   
    Active: boolean;
    CreatedBy: string;
    CreatedDate: Date;
    ModifiedBy: string;
    ModifiedDate: Date;
    DefaultLanguageId:number;
    BU?: BU | null;
    Region?: Region | null;
    SubBU?: SubBU | null;
    Site?: Site | null;
    Attributes?: Attributes[]|null;
    HierarchyTranslations?: HierarchyTranslation[] | null;
    Sites?: Site[] | null;
    SRUs?: SRU[] | null;
    Departments?:Department[]|null;
    Crews?:Crew[]|null;
}